import styled from 'styled-components';
import academyStyles from './academy-styles';

export default function AcademyIconSvgTlc(props) {
  const defaultWidth = 20;
  const defaultHeight = 16;

  const height = props.height || defaultHeight;
  const calculatedWidth = (defaultWidth / defaultHeight) * height;

  return (
    <AcademyIconWrapper width={calculatedWidth} height={height}>
      <canvas width={calculatedWidth} height={height} />
      <svg width={calculatedWidth} height={height} viewBox="0 0 20 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" opacity="0.5">
          <g transform="translate(-574.000000, -1950.000000)">
            <g transform="translate(550.000000, 1732.000000)">
              <g transform="translate(24.000000, 216.000000)">
                <path
                  d="M10,5 L11.3167184,4.34164079 C13.0813216,3.4593392 15.0271137,3 17,3 L17,3 L17,3 L17,15 C15.0271137,15 13.0813216,15.4593392 11.3167184,16.3416408 L10,17 L10,17 L10,5 Z"
                  stroke={props.color || academyStyles.common.contentTypeIconColor}
                  strokeLinejoin="round"
                />
                <path
                  d="M3,5 L4.31671843,4.34164079 C6.08132161,3.4593392 8.02711367,3 10,3 L10,3 L10,3 L10,15 C8.02711367,15 6.08132161,15.4593392 4.31671843,16.3416408 L3,17 L3,17 L3,5 Z"
                  stroke={props.color || academyStyles.common.contentTypeIconColor}
                  strokeLinejoin="round"
                  transform="translate(6.500000, 10.000000) scale(-1, 1) translate(-6.500000, -10.000000) "
                />
                <polyline
                  stroke={props.color || academyStyles.common.contentTypeIconColor}
                  strokeLinejoin="round"
                  points="17 5 19 5 19 17 1 17 1 5 3 5"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </AcademyIconWrapper>
  );
}

const AcademyIconWrapper = styled.div`
  display: inline-block;
  position: relative;
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
  canvas {
    visibility: hidden;
  }
  svg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100% !important;
  }
`;
